













































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { timeout } from '@/helpers/generic'
import Axios from 'axios'
import { Track } from '../../../../classes/track'
import { LibraryMixin } from '@/mixins'
import { spawn, Thread, Worker } from 'threads'
import { waitForMinimumDelay } from '../../../../helpers/date'

@Component({
  components: {
    HelpCircle: require('@/components/HelpCircle').default,
    ProgressLoader: require('@/components/ProgressLoader').default
  }
})
export default class KeyConverter extends Mixins(LibraryMixin) {
  scanned: boolean = false
  loading: boolean = false
  notation: string | null = null
  keySummary: any = {}
  invalidKeys: string[] = []

  optionAddLeadingZero: boolean = true

  get disabled(): boolean {
    return this.notation === null
  }

  async scan() {
    if (this.loading || this.scanned || !this.library) return

    this.loading = true

    const startTime = new Date()

    const worker = await spawn(new Worker('@/helpers/features/key-converter'))

    this.keySummary = await worker.getKeySummary(this.library.tracks)

    await Thread.terminate(worker)

    await waitForMinimumDelay(startTime, 500)

    this.loading = false
    this.scanned = true
  }

  async convertKeys() {
    if (this.loading) return

    this.loading = true

    try {
      const { data } = await Axios.post('/library/convert-keys', {
        notation: this.notation,
        addLeadingZero: this.optionAddLeadingZero
      })

      await this.$store.dispatch('library/fetchLibrary')

      let message = `Key conversion complete`

      const hasInvalidKeys: boolean = data !== this.keySummary.OPEN_KEY + this.keySummary.CAMELOT_KEY + this.keySummary.OTHER

      if (hasInvalidKeys) {
        message += '. However, not all keys could be converted.'

        const worker = await spawn(new Worker('@/helpers/features/key-converter'))

        const invalidKeyTracks: Track[] = await worker.getUnrecognizedKeyTracks(this.library.tracks)

        await Thread.terminate(worker)

        this.invalidKeys = [...new Set(invalidKeyTracks.map(t => t.key))]
      }

      this.$buefy.notification.open({
        message,
        duration: 15000,
        type: hasInvalidKeys ? 'is-warning' : 'is-primary'
      })
    } catch (error) {
      console.error(error)

      if (this.$store.state.auth.isDemoUser) {
        this.$buefy.notification.open(`Key conversion complete`)
      }
    }

    this.loading = false
    this.scanned = false

    await this.scan()
  }

  async created() {
    await this.scan()
  }

  @Watch('$store.state.library.library')
  async watchLibrary() {
    await timeout(10)

    await this.scan()
  }
}
